import { render, staticRenderFns } from "./GTItemReport.vue?vue&type=template&id=0c0bd2d9&"
import script from "./GTItemReport.vue?vue&type=script&lang=js&"
export * from "./GTItemReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports